export var defaultLocaleStrings = {
    'New': 'New',
    'Insert Footnote': 'Insert Footnote',
    'Insert Endnote': 'Insert Endnote',
    'Footnote Tooltip': 'Insert Footnote (Alt+Ctrl+F).',
    'Endnote Tooltip': 'Insert Endnote (Alt+Ctrl+D).',
    'Open': 'Open',
    'Undo': 'Undo',
    'Redo': 'Redo',
    'Image': 'Image',
    'Table': 'Table',
    'Link': 'Link',
    'Bookmark': 'Bookmark',
    'Table of Contents': 'Table of Contents',
    'HEADING - - - - 1': 'HEADING - - - - 1',
    'HEADING - - - - 2': 'HEADING - - - - 2',
    'HEADING - - - - 3': 'HEADING - - - - 3',
    'Header': 'Header',
    'Footer': 'Footer',
    'XML Mapping Pane': 'XML Mapping Pane',
    'Page Setup': 'Page Setup',
    'Page Number': 'Page Number',
    'Break': 'Break',
    'Find': 'Find',
    'Local Clipboard': 'Local Clipboard',
    'Restrict Editing': 'Restrict Editing',
    'Upload from computer': 'Upload from computer',
    'By URL': 'By URL',
    'Page': 'Page',
    'Show properties pane': 'Show properties pane',
    'Hide properties pane': 'Hide properties pane',
    'Next Page': 'Next Page',
    'Continuous': 'Continuous',
    'Header And Footer': 'Header & Footer',
    'Options': 'Options',
    'XML Mapping': 'XML Mapping',
    'Custom XML Part:': 'Custom XML Part:',
    'Core Properties': 'Core Properties',
    'Levels': 'Levels',
    'Different First Page': 'Different First Page',
    'Different header and footer for odd and even pages': 'Different header and footer for odd and even pages.',
    'Different Odd And Even Pages': 'Different Odd & Even Pages',
    'Different header and footer for first page': 'Different header and footer for first page.',
    'Position': 'Position',
    'Header from Top': 'Header from Top',
    'Footer from Bottom': 'Footer from Bottom',
    'Distance from top of the page to top of the header': 'Distance from top of the page to top of the header.',
    'Distance from bottom of the page to bottom of the footer': 'Distance from bottom of the page to bottom of the footer.',
    'Aspect ratio': 'Aspect ratio',
    'W': 'W',
    'H': 'H',
    'Width': 'Width',
    'Height': 'Height',
    'Text': 'Text',
    'Paragraph': 'Paragraph',
    'Fill': 'Fill',
    'Fill color': 'Fill color',
    'Border Style': 'Border Style',
    'Outside borders': 'Outside borders',
    'All borders': 'All borders',
    'Inside borders': 'Inside borders',
    'Left border': 'Left border',
    'Inside vertical border': 'Inside vertical border',
    'Right border': 'Right border',
    'Top border': 'Top border',
    'Inside horizontal border': 'Inside horizontal border',
    'Bottom border': 'Bottom border',
    'Border color': 'Border color',
    'Border width': 'Border width',
    'Cell': 'Cell',
    'Merge cells': 'Merge cells',
    'Insert Or Delete': 'Insert / Delete',
    'Insert columns to the left': 'Insert columns to the left',
    'Insert columns to the right': 'Insert columns to the right',
    'Insert rows above': 'Insert rows above',
    'Insert rows below': 'Insert rows below',
    'Delete rows': 'Delete rows',
    'Delete columns': 'Delete columns',
    'Cell Margin': 'Cell Margin',
    'Top': 'Top',
    'Bottom': 'Bottom',
    'Left': 'Left',
    'Right': 'Right',
    'Align Text': 'Align Text',
    'Align top': 'Align top',
    'Align bottom': 'Align bottom',
    'Align center': 'Align center',
    'Number of heading or outline levels to be shown in table of contents': 'Number of heading or outline levels to be shown in table of contents.',
    'Show page numbers': 'Show page numbers',
    'Show page numbers in table of contents': 'Show page numbers in table of contents.',
    'Right align page numbers': 'Right align page numbers',
    'Right align page numbers in table of contents': 'Right align page numbers in table of contents.',
    'Use hyperlinks': 'Use hyperlinks',
    'Use hyperlinks instead of page numbers': 'Use hyperlinks instead of page numbers.',
    'Font': 'Font',
    'Font Size': 'Font Size',
    'Font color': 'Font color',
    'Text highlight color': 'Text highlight color',
    'Clear all formatting': 'Clear all formatting',
    'Bold Tooltip': 'Bold (Ctrl+B)',
    'Italic Tooltip': 'Italic (Ctrl+I)',
    'Underline Tooltip': 'Underline (Ctrl+U)',
    'Strikethrough': 'Strikethrough',
    'Superscript Tooltip': 'Superscript (Ctrl+Shift++)',
    'Subscript Tooltip': 'Subscript (Ctrl+=)',
    'Align left Tooltip': 'Align left (Ctrl+L)',
    'Center Tooltip': 'Center (Ctrl+E)',
    'Align right Tooltip': 'Align right (Ctrl+R)',
    'Justify Tooltip': 'Justify (Ctrl+J)',
    'Decrease indent': 'Decrease indent',
    'Increase indent': 'Increase indent',
    'Line spacing': 'Line spacing',
    'Bullets': 'Bullets',
    'Numbering': 'Numbering',
    'Styles': 'Styles',
    'Manage Styles': 'Manage Styles',
    'of': 'of',
    'Fit one page': 'Fit one page',
    'Spell Check': 'Spell Check',
    'Spelling': 'Spelling',
    'Underline errors': 'Underline errors',
    'Fit page width': 'Fit page width',
    'Update': 'Update',
    'Cancel': 'Cancel',
    'Insert': 'Insert',
    'No Border': 'No Border',
    'Create a new document': 'Create a new document.',
    'Open a document': 'Open a document.',
    'Undo Tooltip': 'Undo the last operation (Ctrl+Z).',
    'Redo Tooltip': 'Redo the last operation (Ctrl+Y).',
    'Insert inline picture from a file': 'Insert inline picture from a file.',
    'Insert a table into the document': 'Insert a table into the document',
    'Create Hyperlink': 'Create a link in your document for quick access to web pages and files (Ctrl+K).',
    'Insert a bookmark in a specific place in this document': 'Insert a bookmark in a specific place in this document.',
    'Provide an overview of your document by adding a table of contents': 'Provide an overview of your document by adding a table of contents.',
    'Add or edit the header': 'Add or edit the header.',
    'Add or edit the footer': 'Add or edit the footer.',
    'Open the page setup dialog': 'Open the page setup dialog.',
    'Content Control': 'Content Control',
    'Insert Content Control': 'Insert Content Control',
    'Add page numbers': 'Add page numbers.',
    'Find Text': 'Find text in the document (Ctrl+F).',
    'Replace Text': 'Replace text in the document (Ctrl+H).',
    'Toggle between the internal clipboard and system clipboard': 'Toggle between the internal clipboard and system clipboard.</br>' +
        'Access to system clipboard through script is denied due to browsers security policy. Instead, </br>' +
        ' 1. You can enable internal clipboard to cut, copy and paste within the component.</br>' +
        ' 2. You can use the keyboard shortcuts (Ctrl+X, Ctrl+C and Ctrl+V) to cut, copy and paste with system clipboard.',
    'Current Page Number': 'The current page number in the document. Click or tap to navigate specific page.',
    'Read only': 'Read only',
    'Protections': 'Protections',
    'Error in establishing connection with web server': 'Error in establishing connection with web server',
    'Single': 'Single',
    'Double': 'Double',
    'New comment': 'New comment',
    'Comments': 'Comments',
    'Print layout': 'Print layout',
    'Web layout': 'Web layout',
    'Form Fields': 'Form Fields',
    'Text Form': 'Text Form',
    'Check Box': 'Check Box',
    'DropDown': 'Drop-Down',
    'Update Fields': 'Update Fields',
    'Update cross reference fields': 'Update cross reference fields',
    'Track Changes': 'Keep track of the changes made in the document',
    'TrackChanges': 'Track Changes',
    'AllCaps': 'AllCaps',
    'Change case Tooltip': 'Change case',
    'UPPERCASE': 'UPPERCASE',
    'SentenceCase': 'Sentence case',
    'Lowercase': 'lowercase',
    'CapitalizeEachWord': 'Capitalize Each Word',
    'ToggleCase': 'tOGGLE cASE',
    'No color': 'No color',
    'Top margin': 'Top margin',
    'Bottom margin': 'Bottom margin',
    'Left margin': 'Left margin',
    'Right margin': 'Right margin',
    'Normal': 'Normal',
    'Heading': 'Heading',
    'Heading 1': 'Heading 1',
    'Heading 2': 'Heading 2',
    'Heading 3': 'Heading 3',
    'Heading 4': 'Heading 4',
    'Heading 5': 'Heading 5',
    'Heading 6': 'Heading 6',
    'Heading 7': 'Heading 7',
    'Heading 8': 'Heading 8',
    'Heading 9': 'Heading 9',
    'ZoomLevelTooltip': 'Zoom level. Click or tap to open the Zoom options.',
    'None': 'None',
    'Borders': 'Borders',
    'ShowHiddenMarks Tooltip': 'Show the hidden characters like spaces, tab, paragraph marks, and breaks.(Ctrl + *)',
    'Columns': 'Columns',
    'Column': 'Column',
    'Page Breaks': 'Page Breaks',
    'Section Breaks': 'Section Breaks',
    'Link to Previous': 'Link to Previous',
    'Link to PreviousTooltip': 'Link this section with previous section header or footer',
    'Alternate Text': 'Alternate Text',
    'The address of this site is not valid. Check the address and try again.': 'The address of this site is not valid. Check the address and try again.',
    'OK': 'OK',
    'Information': 'Information',
    'Rich Text Content Control': 'Rich Text Content Control',
    'Plain Text Content Control': 'Plain Text Content Control',
    'Picture Content Control': 'Picture Content Control',
    'Combo Box Content Control': 'Combo Box Content Control',
    'Drop-Down List Content Control': 'Drop-Down List Content Control',
    'Date Picker Content Control': 'Date Picker Content Control',
    'Check Box Content Control': 'Check Box Content Control',
    'Header & Footer': 'Header & Footer',
    'Comment': 'Comment',
    'Links': 'Links',
    'Illustrations': 'Illustrations',
    'Tables': 'Tables',
    'Home': 'Home',
    'Cut': 'Cut',
    'Copy': 'Copy',
    'Replace': 'Replace',
    'Clipboard': 'Clipboard',
    // Add these to the defaultLocale object in document-editor-container.ts
    'Views': 'Views',
    'Zoom': 'Zoom',
    'Zoom In': 'Zoom In',
    'Zoom Out': 'Zoom Out',
    'One Page': 'One Page',
    'Page Width': 'Page Width',
    'Show': 'Show',
    'Ruler': 'Ruler',
    'Show Bookmarks': 'Show Bookmarks',
    'View': 'View',
    'Page Numbers': 'Page Numbers',
    'Insert automatic page numbering': 'Insert automatic page numbering',
    'Previous Section': 'Previous Section',
    'Next Section': 'Next Section',
    'Navigation': 'Navigation',
    'Close': 'Close',
    'Close Header and Footer': 'Close Header and Footer',
    'Close header and footer view': 'Close header and footer view',
    'Link to the previous sections header and footer': 'Link to the previous sections header and footer',
    // Add to defaultLocale object in document-editor-container.ts
    'Picture Format': 'Picture Format',
    'Picture Tools': 'Picture Tools',
    'Adjust image width': 'Adjust image width',
    'Adjust image height': 'Adjust image height',
    'Maintain aspect ratio when resizing': 'Maintain aspect ratio when resizing',
    'Add descriptive text for screen readers': 'Add descriptive text for screen readers',
    'Enter alternate text': 'Enter alternate text',
    'Adjust image width and height': 'Adjust image width and height',
    'Page Break': 'Page Break',
    'Pages': 'Pages',
    'References': 'References',
    // Page Setup Group
    'Margins': 'Margins',
    'Narrow': 'Narrow',
    'Moderate': 'Moderate',
    'Wide': 'Wide',
    'Custom Margins': 'Custom Margins',
    'Orientation': 'Orientation',
    'Portrait': 'Portrait',
    'Landscape': 'Landscape',
    'Size': 'Size',
    'Letter': 'Letter',
    'Legal': 'Legal',
    'Executive': 'Executive',
    'A4': 'A4',
    'A5': 'A5',
    'Custom Size': 'Custom Size',
    'One': 'One',
    'Two': 'Two',
    'Three': 'Three',
    'More Columns': 'More Columns',
    'Breaks': 'Breaks',
    // Paragraph Group
    'Left Indent': 'Left Indent',
    'Right Indent': 'Right Indent',
    'Before Spacing': 'Before Spacing',
    'After Spacing': 'After Spacing',
    // Layout Tab
    'Layout': 'Layout',
    'Footnotes': 'Footnotes',
    'Update Table': 'Update Table',
    'PageSetup': 'Page Setup',
    'Indent': 'Indent',
    'Spacing': 'Spacing',
    'CustomPageSize': 'Custom Size...',
    'MoreColumns': 'More Columns...',
    'PageBreak': 'Page Break',
    'ColumnBreak': 'Column Break',
    'Before': 'Before',
    'After': 'After',
    // Tooltips
    'LeftIndent': 'Left',
    'LeftIndentTooltip': 'Set the left indent for the paragraph',
    'RightIndent': 'Right',
    'RightIndentTooltip': 'Set the right indent for the paragraph',
    'SpacingBefore': 'Before',
    'SpacingBeforeTooltip': 'Set the spacing before the paragraph',
    'SpacingAfter': 'After',
    'SpacingAfterTooltip': 'Set the spacing after the paragraph',
    'ParagraphDialogTooltip': 'Open Paragraph dialog',
    'Bookmarks': 'Bookmarks',
    'Insert Bookmark': 'Insert Bookmark',
    'All Bookmarks': 'All Bookmarks',
    'Create or manage bookmarks in your document': 'Create or manage bookmarks in your document',
    'View all bookmarks in the document': 'View all bookmarks in the document',
    'Toggle visibility of bookmark markers in the document': 'Toggle visibility of bookmark markers in the document',
    'New Comment': 'New Comment',
    'Add a comment about the current selection': 'Add a comment about the current selection',
    'Insert a table of contents': 'Insert a table of contents',
    'Insert a page break at the current position': 'Insert a page break at the current position',
    'Review': 'Review',
    'Previous': 'Previous',
    'Next': 'Next',
    'Delete': 'Delete',
    'Delete All': 'Delete All',
    'Show Comments': 'Show Comments',
    'Tracking': 'Tracking',
    'Accept All': 'Accept All',
    'Reject All': 'Reject All',
    'Protect': 'Protect',
    'Protect Document': 'Protect Document',
    'Read Only': 'Read Only',
    'Encrypt with Password': 'Encrypt with Password',
    'Restrict Access': 'Restrict Access',
    'Mark as Final': 'Mark as Final',
    'Insert a comment at the cursor position': 'Insert a comment at the cursor position',
    'Go to the previous comment': 'Go to the previous comment',
    'Go to the next comment': 'Go to the next comment',
    'Delete comments': 'Delete comments',
    'Show or hide comments': 'Show or hide comments',
    'Track changes while editing the document': 'Track changes while editing the document',
    'Accept all changes in the document': 'Accept all changes in the document',
    'Reject all changes in the document': 'Reject all changes in the document',
    'Control what types of changes can be made to the document': 'Control what types of changes can be made to the document',
    'Make the document read-only': 'Make the document read-only',
    'Restrict how users can edit the document': 'Restrict how users can edit the document',
    'Print Layout': 'Print Layout',
    'Web Layout': 'Web Layout',
    'Toggle document to read only mode': 'Toggle document to read only mode',
    'Navigation Pane': 'Navigation Pane',
    'Show or hide the navigation pane': 'Show or hide the navigation pane',
    'Grow Font Size': 'Grow Font Size (Ctrl+Shift+>)',
    'Shrink Font Size': 'Shrink Font Size (Ctrl+Shift+<)',
    'Shading': 'Shading',
    'Select': 'Select',
    'Row': 'Row',
    'Rows & Columns': 'Rows & Columns',
    'Table Layout': 'Table Layout',
    'Row Above': 'Row Above',
    'Row Below': 'Row Below',
    'Column Left': 'Column Left',
    'Column Right': 'Column Right',
    'Cut Tooltip': 'Cut (Ctrl+X)',
    'Copy Tooltip': 'Copy (Ctrl+C)',
    '100%': '100%',
    'Zoom your document to 100%': 'Zoom your document to 100%',
    // Margin dropdown localization texts
    'Office2003Default': 'Office 2003 Default',
    'CustomMargins': 'Custom Margins...',
    'MarginsTooltip': 'Choose page margin settings for the document',
    'Indent Left': 'Indent Left',
    'Indent Right': 'Indent Right',
    'Spacing Before': 'Spacing Before',
    'Spacing After': 'Spacing After',
    'Set the distance between paragraph and left margin': 'Set the distance between paragraph and left margin',
    'Set the distance between paragraph and right margin': 'Set the distance between paragraph and right margin',
    'Set the spacing before the paragraph': 'Set the spacing before the paragraph',
    'Set the spacing after the paragraph': 'Set the spacing after the paragraph',
    'Table Design': 'Table Design',
    'Properties': 'Properties',
    'Show the Table Properties dialog': 'Show the Table Properties dialog',
    // Alt Text Dialog
    'Alt Text': 'Alt Text',
    'Alternative Text': 'Alternative Text',
    'Enter alt text for this image': 'Enter alt text for this image',
    'Apply': 'Apply',
    // Picture Format Tab - Alt Text Group
    'Accessibility': 'Accessibility',
    'Add alternative text to the image for accessibility': 'Add alternative text to the image for accessibility',
    'File': 'File',
    'Export': 'Export',
    'Print': 'Print',
    'Syncfusion Document Text (*.sfdt)': 'Syncfusion Document Text (*.sfdt)',
    'Word Document (*.docx)': 'Word Document (*.docx)',
    'Word Template (*.dotx)': 'Word Template (*.dotx)',
    'Plain Text (*.txt)': 'Plain Text (*.txt)',
    'Unsupported format': 'Unsupported format',
    'BackstageView': 'Backstage View',
    'BackstageHeader': 'File Management',
    'BackstageClose': 'Close',
    // Developer tab
    'Developer': 'Developer',
    // Form Fields group
    'Insert form fields': 'Insert form fields',
    // Controls group
    'Controls': 'Controls',
    'Insert content controls': 'Insert content controls',
    // Mapping group
    'Mapping': 'Mapping',
    'Restrict editing': 'Restrict editing',
    'More Paragraph Options': 'More Paragraph Options',
    'More Font Options': 'More Font Options',
    'Show/Hide Marks': 'Show/Hide Marks',
    'All Borders': 'All Borders',
    'Outside Borders': 'Outside Borders',
    'Inside Borders': 'Inside Borders',
    'Top Border': 'Top Border',
    'Bottom Border': 'Bottom Border',
    'Left Border': 'Left Border',
    'Right Border': 'Right Border',
    'Inside Horizontal Border': 'Inside Horizontal Border',
    'Inside Vertical Border': 'Inside Vertical Border',
    'Table Borders': 'Table Borders',
    'Border Color': 'Border Color',
    'Border Width': 'Border Width',
    'px': 'px',
    'SizeTooltip': 'Choose a paper size for the document',
    'OrientationTooltip': 'Choose the page orientation',
    'ColumnsTooltip': 'Choose the columns for the document',
    'Insert rows and columns': 'Insert rows and columns',
    'Select the table': 'Select the table',
    'Delete the table': 'Delete the table',
    'Cell Properties': 'Cell Properties',
    'Show or hide the rulers': 'Show or hide the rulers',
    'Show or hide bookmarks': 'Show or hide bookmarks'
};
